module.exports = __webpack_public_path__ + "img/credit-card.2be12bd2.svg";